var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('div',{staticClass:"resourceTiles"},_vm._l((_vm.bundles),function(bundle){return _c('bundle-tile',{key:bundle.slug,attrs:{"bundle":bundle,"slug":bundle.slug}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }